module.exports = __webpack_public_path__ + "media/images/docspin-logo-fc9a65ec4fb16f4db97314ec4889d0f7.svg";